import React, { useState } from 'react';
import { LABELS, sectionStats, sectionSummary } from './itAppRules';

function billingText(app) {
  const billing = LABELS.billing[app.billing] || app.billing;
  if (app.billing !== 'no_cost' && app.billed_by === 'partner' && app.partner_name) {
    return `${billing} · Billed by ${app.partner_name}`;
  }
  return billing;
}

// The linked catalog tool is optional: null, absent, or an object without an
// id all render no marker, so a half-loaded row never claims a link.
const inCatalog = (app) => !!(app.tool && app.tool.id != null);

function AppRow({ app, onOpen }) {
  const retired = app.active === false;
  return (
    <li>
      <button type="button" className={`ita-row${retired ? ' is-retired' : ''}`} onClick={() => onOpen(app)}>
        <span className="ita-cell ita-cell--name">
          <span className="ita-name">{app.name}</span>
          {inCatalog(app) && <span className="ita-chip ita-chip--catalog">In catalog</span>}
          {retired && <span className="ita-chip">Retired</span>}
        </span>
        <span className="ita-cell" data-label="Sign-in">{LABELS.sign_in[app.sign_in] || app.sign_in}</span>
        <span className="ita-cell" data-label="Billing">{billingText(app)}</span>
        <span className="ita-cell" data-label="IT owner">{app.it_owner || <span className="ita-muted">None</span>}</span>
      </button>
    </li>
  );
}

/**
 * One company's apps. `allApps` drives the header numbers (stable while the
 * user searches or filters); `apps` are the rows currently shown.
 */
export default function ItAppSection({ company, allApps, apps, onOpen }) {
  const [open, setOpen] = useState(true);
  const label = LABELS.company[company];
  const headingId = `ita-sec-${company}`;
  const listId = `ita-list-${company}`;
  return (
    <section className={`ita-section${open ? '' : ' is-collapsed'}`} aria-labelledby={headingId}>
      <div className="ita-section-head">
        <h2 id={headingId} className="ita-section-title">
          <button
            type="button"
            className="ita-section-toggle"
            aria-expanded={open}
            aria-controls={listId}
            onClick={() => setOpen((o) => !o)}
          >
            <svg className="ita-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="m9 6 6 6-6 6" />
            </svg>
            {label}
          </button>
        </h2>
        <span className="ita-section-stats">{sectionSummary(sectionStats(allApps))}</span>
      </div>
      {/* Stays mounted while collapsed so aria-controls always names a real element. */}
      <div id={listId} className="ita-section-body" hidden={!open}>
        {apps.length === 0 ? (
          <p className="ita-section-empty">No apps in {label} yet.</p>
        ) : (
          <>
            <div className="ita-colhead" aria-hidden="true">
              <span>App</span><span>Sign-in</span><span>Billing</span><span>IT owner</span>
            </div>
            <ul className="ita-rows">
              {apps.map((a) => <AppRow key={a.id} app={a} onOpen={onOpen} />)}
            </ul>
          </>
        )}
      </div>
    </section>
  );
}
